import axios from "../plugins/parseAxios";
export class BillingSettingAPI {
  constructor(props) { }
  static createBillingSetting(payload) {
    return axios.post("functions/createBillingSetting", payload);
  }
  static getBillingSettings(payload) {
    return axios.post("functions/getBillingSettings", {
      areaId: payload.areaId
    });
  }
  static updateBillingSetting(payload) {
    return axios.post("functions/updateBillingSetting", payload);
  }
  static removeBillingSetting(payload) {
    return axios.post("functions/removeBillingSetting", payload);
  }
  static getBillingSettingsByAreas(payload) {
    return axios.post("functions/getBillingSettingsByAreas", payload)
  }
  static getBillingSettingsByIncludeArea(payload) {
    return axios.post("functions/getBillingSettingsByIncludeArea", { areaIds: payload.areaIds })
  }
  static getBillingSettingsByMeters(payload) {
    return axios.post("functions/getBillingSettingsByMeters", payload)
  }
  static getBillingSettingsByIds(ids) {
    return axios.post("functions/getBillingSettingsByIds", {
      ids
    });
  }
}
